import React from 'react';
import PropTypes from 'prop-types';
import { RESOURCE_TYPE } from '../../HelperMethods/role-resource-constants';
import useAuthorization from '../../hooks/useAuthorization';

const ShouldComponentRender = React.memo(function ShouldComponentRender({
  children,
  resourceType,
  resource,
  entityAccessType,
  entity,
}) {
  const isAuthorized = useAuthorization({
    resourceType,
    resource,
    entityAccessType,
    entity,
  });

  return isAuthorized ? children : null;
});

ShouldComponentRender.propTypes = {
  children: PropTypes.node.isRequired,
  resourceType: PropTypes.oneOf(Object.values(RESOURCE_TYPE)).isRequired,
  resource: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
  entityAccessType: PropTypes.string,
  entity: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
};

ShouldComponentRender.defaultProps = {
  entityAccessType: null,
  entity: null,
};

export default ShouldComponentRender;
